import cn from 'classnames';
import { useState } from 'react';

import { SidebarMenu, TableOfContent } from '@/components/static';
import { TOC_UPDATE_DELAY_MS } from '@/constant/common';
import { TOCContextProvider } from '@/context/TOC';
import { useAnchor, useScrollToAnchorOnMount } from '@/hooks/navigation';
import { useAutoUpdateActiveTOC } from '@/hooks/navigation';
import { useTimeout } from '@/hooks/useTimeout';

import { NavPanel } from './NavPanel';
import s from './styles.module.scss';
import { PageNavigationProps } from './types';

export function Navigation({ children, TOCList, TOCClassName, getActiveElementParentIdsPred }: PageNavigationProps) {
  // const { activeTOCElement } = useTOCDataCtx();
  const [shouldSkipObserver, setShouldSkipObserver] = useState(true);
  const { anchor } = useAnchor();

  const onScrollToElementEnd = () => {
    setShouldSkipObserver(false);
  };

  const onScrollToElementEndWithTimeout = useTimeout(onScrollToElementEnd, TOC_UPDATE_DELAY_MS);

  useScrollToAnchorOnMount(anchor, onScrollToElementEndWithTimeout);
  // useScrollToAnchorOnMount(activeTOCElement, onScrollToElementEndWithTimeout);

  useAutoUpdateActiveTOC(shouldSkipObserver);

  return (
    <div className={s.page_wrapper}>
      <NavPanel rootClassName={s.hide_on_desktop} TOCList={TOCList} />

      <SidebarMenu rootClassName={s.hide_on_mobile} />
      {children}
      <TableOfContent
        getActiveElementParentIdsPred={getActiveElementParentIdsPred}
        className={cn(s.hide_on_mobile, TOCClassName)}
        customList={TOCList}
      />
    </div>
  );
}

export function PageNavigation(props: PageNavigationProps) {
  return (
    <TOCContextProvider>
      <Navigation {...props}>{props.children}</Navigation>
    </TOCContextProvider>
  );
}
